/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApiStatsDto } from '../models/api-stats-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { MethodStatDto } from '../models/method-stat-dto';


/**
 * Fonctions de gestion des statistiques des APIs
 */
@Injectable({
  providedIn: 'root',
})
export class StatistiquesApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiStatisticsGetApiStats
   */
  static readonly ApiStatisticsGetApiStatsPath = '/api/statistiques-api/all';

  /**
   * Renvoie les statistiques de l'API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStatisticsGetApiStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGetApiStats$Response(params?: {
  }): Observable<StrictHttpResponse<ApiStatsDto>> {

    const rb = new RequestBuilder(this.rootUrl, StatistiquesApiService.ApiStatisticsGetApiStatsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiStatsDto>;
      })
    );
  }

  /**
   * Renvoie les statistiques de l'API.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStatisticsGetApiStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGetApiStats(params?: {
  }): Observable<ApiStatsDto> {

    return this.apiStatisticsGetApiStats$Response(params).pipe(
      map((r: StrictHttpResponse<ApiStatsDto>) => r.body as ApiStatsDto)
    );
  }

  /**
   * Path part for operation apiStatisticsGetApiStatsNoPermissions
   */
  static readonly ApiStatisticsGetApiStatsNoPermissionsPath = '/api/statistiques-api/all-no-permissions';

  /**
   * Renvoie les statistiques de l'API (méthodes sans permissions, pas anonymes, uniquement).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStatisticsGetApiStatsNoPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGetApiStatsNoPermissions$Response(params?: {
  }): Observable<StrictHttpResponse<ApiStatsDto>> {

    const rb = new RequestBuilder(this.rootUrl, StatistiquesApiService.ApiStatisticsGetApiStatsNoPermissionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiStatsDto>;
      })
    );
  }

  /**
   * Renvoie les statistiques de l'API (méthodes sans permissions, pas anonymes, uniquement).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStatisticsGetApiStatsNoPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGetApiStatsNoPermissions(params?: {
  }): Observable<ApiStatsDto> {

    return this.apiStatisticsGetApiStatsNoPermissions$Response(params).pipe(
      map((r: StrictHttpResponse<ApiStatsDto>) => r.body as ApiStatsDto)
    );
  }

  /**
   * Path part for operation apiStatisticsLoadList
   */
  static readonly ApiStatisticsLoadListPath = '/api/statistiques-api/load-list';

  /**
   * Renvoie la liste des méthodes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStatisticsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStatisticsLoadList$Response(params: {

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, StatistiquesApiService.ApiStatisticsLoadListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des méthodes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStatisticsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStatisticsLoadList(params: {

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.apiStatisticsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation apiStatisticsGet
   */
  static readonly ApiStatisticsGetPath = '/api/statistiques-api/{id}';

  /**
   * Renvoie le rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStatisticsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGet$Response(params: {

    /**
     * Identifiant du rôle
     */
    id: number;
  }): Observable<StrictHttpResponse<MethodStatDto>> {

    const rb = new RequestBuilder(this.rootUrl, StatistiquesApiService.ApiStatisticsGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MethodStatDto>;
      })
    );
  }

  /**
   * Renvoie le rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStatisticsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStatisticsGet(params: {

    /**
     * Identifiant du rôle
     */
    id: number;
  }): Observable<MethodStatDto> {

    return this.apiStatisticsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MethodStatDto>) => r.body as MethodStatDto)
    );
  }

}
